import { render, staticRenderFns } from "./StudyConfigurationNotice.vue?vue&type=template&id=9d74e0e4&"
import script from "./StudyConfigurationNotice.vue?vue&type=script&lang=js&"
export * from "./StudyConfigurationNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports